module.exports = __webpack_public_path__ + "img/content.48040e30.png";